import type { ChangeEvent, FC, MouseEvent } from 'react';
import {
    Box,
    Input,
    InputLabel,
    Stack,
    ToggleButton,
    ToggleButtonGroup,
} from '@mui/material';
import { DistanceType, type ProductRoute } from '@travelity/api/services';
import { useController, useFormContext } from 'react-hook-form';
import type { ProductRouteStepDistanceProps } from './ProductRouteStepDistance.types';

export const ProductRouteStepDistance: FC<ProductRouteStepDistanceProps> = ({
    isEditing,
}) => {
    const { control } = useFormContext<ProductRoute>();
    const {
        field: { value: distance, onChange },
    } = useController({
        name: 'distance',
        control,
        defaultValue: {
            value: 0,
            type: DistanceType.KM,
        },
    });

    const handleChangeDistanceValue = ({
        target,
    }: ChangeEvent<HTMLInputElement>) => {
        onChange({ ...distance, value: Number(target.value) });
    };

    const handleSwitchDistanceType = (
        _: MouseEvent<HTMLElement>,
        newValue: DistanceType
    ) => {
        onChange({ ...distance, type: newValue });
    };

    return (
        <Box
            maxWidth="452px"
            sx={{
                display: 'flex',
                alignItems: 'flex-end',
                gap: '8px',
                mb: 2,
                padding: '0 8px',
            }}
        >
            <Stack direction="column" spacing={1} width="100%">
                <InputLabel
                    htmlFor="distance"
                    sx={{ fontSize: '16px', fontWeight: 'normal' }}
                >
                    Distance
                </InputLabel>
                <Input
                    id="standard-basic"
                    type="number"
                    value={distance.value || ''}
                    onChange={handleChangeDistanceValue}
                    disabled={isEditing}
                />
            </Stack>
            <ToggleButtonGroup
                value={distance.type}
                onChange={handleSwitchDistanceType}
                disabled={isEditing}
                exclusive
            >
                <ToggleButton
                    value={DistanceType.KM}
                    sx={{
                        width: '40px',
                        padding: '4px 8px',
                        textTransform: 'capitalize',
                    }}
                >
                    {DistanceType.KM}
                </ToggleButton>
                <ToggleButton
                    value={DistanceType.MILE}
                    sx={{
                        width: '40px',
                        padding: '4px 8px',
                        textTransform: 'capitalize',
                    }}
                >
                    {DistanceType.MILE}
                </ToggleButton>
            </ToggleButtonGroup>
        </Box>
    );
};
